import {
  Message
} from 'element-ui'

export const timeToLocal = (date) => {
  const year = date.getFullYear()
  const month = date.getMonth()
  const day = date.getDate()
  const hours = date.getHours()
  const min = date.getMinutes()
  const sec = date.getSeconds()
  const datetmp = `${year}年${
    month + 1 >= 10 ? month + 1 : `0${month + 1}`
  }月${day >= 10 ? day : `0${day}`}日`
  const time = `${hours >= 10 ? hours : `0${hours}`}:${
    min >= 10 ? min : `0${min}`
  }:${sec >= 10 ? sec : `0${sec}`}`
  const datetime = `${datetmp} ${time}`
  return {
    date: datetmp,
    time,
    datetime
  }
}

export const uuid = () => {
  let d = new Date().getTime()
  const id = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
    /[xy]/g,
    c => {
      const r = (d + Math.random() * 16) % 16 | 0
      d = Math.floor(d / 16)
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
    }
  )
  return id
}

export const winAlert = () => {
  window.alert = function(name) {
    const iframe = document.createElement('IFRAME')
    iframe.style.display = 'none'
    document.documentElement.appendChild(iframe)
    window.frames[0].window.alert(name)
    iframe.parentNode.removeChild(iframe)
  }
}

export const getParams = (key) => {
  const reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)', 'i')
  const result = window.location.search.substr(1).match(reg)
  if (result != null) {
    return decodeURIComponent(result[2])
  }
  return null
}

export const removeLables = (html) => {
  if (!html) return ''
  return html.replace(/<\/?.+?>/g, '')
}

export const getTitle = (title) => {
  const dom = document.createElement('p')
  dom.innerHTML = title
  return dom.textContent
}

export const deepClone = (
  original,
  target = Object.prototype.toString.call(original) === '[object Array]' ? [] : {}
) => {
  for (const prop in original) {
    if (original.hasOwnProperty(prop)) {
      if (typeof original[prop] === 'object') {
        if (
          Object.prototype.toString.call(original[prop]) ===
          '[object Array]'
        ) {
          target[prop] = []
        } else {
          target[prop] = {}
        }
        deepClone(original[prop], target[prop])
      } else {
        target[prop] = original[prop]
      }
    }
  }
  return target
}

export const getTimestamp = () => {
  const now = new Date()
  const year = now.getFullYear()
  const month = now.getMonth() + 1
  const date = now.getDate()
  const hour = now.getHours()
  const minute = now.getMinutes()
  const second = now.getSeconds()
  const milliSecond = now.getMilliseconds()
  return '' + year + month + date + hour + minute + second + milliSecond
}

export const MSG = {
  success(msg) {
    Message({
      type: 'success',
      message: msg
    })
  },
  error(msg) {
    Message({
      type: 'error',
      message: msg
    })
  },
  warning(msg) {
    Message({
      type: 'warning',
      message: msg
    })
  }
}

export const colorRgba = function(sHex, alpha) {
  // 十六进制颜色值的正则表达式
  var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
  /* 16进制颜色转为RGB格式 */
  let sColor = sHex.toLowerCase()
  if (sColor && reg.test(sColor)) {
    if (sColor.length === 4) {
      var sColorNew = '#'
      for (let i = 1; i < 4; i += 1) {
        sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1))
      }
      sColor = sColorNew
    }
    // 处理六位的颜色值
    var sColorChange = []
    for (let i = 1; i < 7; i += 2) {
      sColorChange.push(parseInt('0x' + sColor.slice(i, i + 2)))
    }
    return rgbaToColor('rgba(' + sColorChange.join(',') + ',' + alpha + ')')
  } else if (sColor.indexOf('rgb') !== -1) {
    const parts = sColor.replace(/rgba|rgb|\(|\)/gm, '')
      .split(/\s|,/g).filter((val) => val !== '').map((val, index) => index > 2 ? parseFloat(val) : parseInt(val, 10))
    if (parts.length === 4) {
      parts[3] = alpha
    } else if (parts.length === 3) {
      parts.push(alpha)
    }
    return rgbaToColor('rgba(' + parts.join(',') + ')')
  }
  return sColor
}

function rgbaToColor(color, bkg) {
  let values = color
    .replace(/rgba?\(/, '')
    .replace(/\)/, '')
    .replace(/[\s+]/g, '')
    .split(',')
  let bkgColor = (bkg || 'ffffff')
    .replace(/^#?/, '')
    .match(/(\w){2}/g)
  let a = parseFloat(values[3] || 1),
    r = Math.floor(a * parseInt(values[0]) + (1 - a) * parseInt(bkgColor[0], 16)),
    g = Math.floor(a * parseInt(values[1]) + (1 - a) * parseInt(bkgColor[1], 16)),
    b = Math.floor(a * parseInt(values[2]) + (1 - a) * parseInt(bkgColor[2], 16))
  return '#' +
    ('0' + r.toString(16)).slice(-2) +
    ('0' + g.toString(16)).slice(-2) +
    ('0' + b.toString(16)).slice(-2)
}

// 十六进制颜色转换成rgba格式
export function hexToRgba(hex, opacity) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return `rgba(${parseInt(result[1], 16)},${parseInt(
    result[2],
    16
  )},${parseInt(result[3], 16)},${opacity!== undefined ? opacity : 1})`
}




// WEBPACK FOOTER //
// ./src/utils/utils.js